import { CardContent, Tooltip, Typography } from '@mui/material';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import TitleCardText from '@src/main/ui/components/common/Dashboard/common/fields/title/TitleCardText';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import CloseButton from '@src/main/ui/components/common/buttons/CloseButton';
import { FC } from 'react';
import { IconId } from '../../../Icon/IconId';
import styles from './DashboardCardShowMoreHeader.module.scss';

interface DashboardCardShowMoreHeaderProps {
  title: string;
  icon: IconId;
  isCertified?: boolean;
  highlighFields?: HighlighFields[];
  onClickClose: () => void;
}

const defaultProps = { isCertified: false, highlighFields: undefined };

const DashboardCardShowMoreHeader: FC<DashboardCardShowMoreHeaderProps> = ({
  title,
  icon,
  isCertified,
  onClickClose,
  highlighFields,
}) => (
  <span>
    <span className={styles.dashboardCardShowMoreHeader__close}>
      <CloseButton onClick={onClickClose} />
    </span>
    <CardContent
      sx={{
        paddingRight: 5,
        '&.MuiCardContent-root': {
          paddingBottom: 0,
        },
      }}
    >
      <div className={styles.dashboardCardShowMoreHeader__content}>
        <span className={styles.dashboardCardShowMoreHeader__icon}>
          <Icon iconId={icon} />
        </span>
        <Typography variant="h5">
          <span className={styles.dashboardCardShowMoreHeader__title}>
            <TitleCardText title={title} highlighFields={highlighFields} />
            {isCertified ? (
              <Tooltip title="Certified">
                <span className={styles.dashboardCardShowMoreHeader__certified}>
                  <Icon iconId="certified" />
                </span>
              </Tooltip>
            ) : undefined}
          </span>
        </Typography>
      </div>
    </CardContent>
  </span>
);

DashboardCardShowMoreHeader.defaultProps = defaultProps;

export default DashboardCardShowMoreHeader;
